// Returns its arguments but as a typed tuple
export const tuple = <T extends (number | string | {})[]>(...args: T) => args;
